import { Component, OnInit, OnDestroy, HostListener, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Subject } from 'rxjs';
import { PermissionService, CC_PERMISSIONS } from '../../../services/permission.service';
import { HasPermissionDirective } from '../../../directives/has-permission.directive';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, HasPermissionDirective],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {
  isOpen = false;
  isPinned = false;

  /** Expose constants so the template can reference them directly. */
  readonly P = CC_PERMISSIONS;

  private destroy$ = new Subject<void>();

  /**
   * Bulk Inquiries lives in the Appointments section; users who can't see that
   * section but have marketing access (Marketers) get the link under Marketing.
   */
  get showBulkInquiriesInMarketing(): boolean {
    return (
      this.permissionService.hasMarketingAccess() &&
      !this.permissionService.hasAny(this.P.APPOINTMENTS_MANAGE, this.P.IS_TELEMARKETER)
    );
  }

  constructor(
    private renderer: Renderer2,
    public permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    const pinned = localStorage.getItem('sidebarPinned');
    this.isPinned = pinned === 'true';
    this.isOpen = this.isPinned;

    if (this.isPinned) {
      this.renderer.addClass(document.body, 'sidebar-pinned');
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleSidebar(): void {
    this.isOpen = !this.isOpen;
  }

  togglePin(): void {
    this.isPinned = !this.isPinned;
    localStorage.setItem('sidebarPinned', this.isPinned.toString());

    if (this.isPinned) {
      this.isOpen = true;
      this.renderer.addClass(document.body, 'sidebar-pinned');
    } else {
      this.renderer.removeClass(document.body, 'sidebar-pinned');
    }
  }

  closeSidebar(): void {
    if (!this.isPinned) {
      this.isOpen = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!this.isPinned && this.isOpen && !target.closest('.sidebar') && !target.closest('.sidebar-toggle')) {
      this.isOpen = false;
    }
  }
}
